import React from "react";

const PickListComponentMap={
  accountPickListPopup:React.lazy(()=>import('../components/Account/AccountPickListPopup.js')),
};

export const getPickListPopup=(pickListPopup)=>{
  return PickListComponentMap[pickListPopup]||null;
};
